import { render, staticRenderFns } from "./ShapeObjectMenu.vue?vue&type=template&id=36120668&scoped=true&"
import script from "./ShapeObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./ShapeObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ShapeObjectMenu.vue?vue&type=style&index=0&id=36120668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36120668",
  null
  
)

export default component.exports